import { useEffect, useMemo, useState } from "react";

import { Grid } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import useAlertModal from "hooks/useAlertModal";
import { useFormContext } from "react-hook-form";
import useDispatch from "hooks/useDispatch";
import { borrowInsert } from "store/slices/borrow/borrowSlice";

function BorrowSubmit({ onClose }) {
  const [loading, setLoading] = useState(false)

  const alert = useAlertModal();
  const dispatch = useDispatch();

  const { handleSubmit, watch } = useFormContext();
  const amount = watch("amount");

  const isButtonDisabled = useMemo(() => !amount, [amount]);

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await dispatch(borrowInsert(data))

      alert({
        text: "عملیات با موفقیت انجام شد.",
        variant: "success",
        onClose: onClose,
      });

      setLoading(false)
    } catch {
      setLoading(false)
    }

  };

  useEffect(() => { }, []);

  return (
    <Grid item xs={12}>
      <LoadingButton
        disabled={isButtonDisabled}
        fullWidth
        variant="contained"
        loading={loading}
        color="success"
        onClick={handleSubmit(onSubmit)}
      >
        تایید
      </LoadingButton>
    </Grid>
  );
}

export default BorrowSubmit;
